export class HttpError extends Error {
    constructor(
        public readonly status: number,
        message: string,
        public readonly body?: unknown,
    ) {
        super(message);
        this.name = "HttpError";
    }
}

export class UnauthorizedError extends HttpError {
    constructor(message = "Unauthorized", body?: unknown) {
        super(401, message, body);
        this.name = "UnauthorizedError";
    }
}

export class PermissionError extends HttpError {
    constructor(
        message: string,
        public readonly resource?: string,
        public readonly action?: string,
        body?: unknown,
    ) {
        super(403, message, body);
        this.name = "PermissionError";
    }
}

export class ServerError extends HttpError {
    constructor(
        message: string,
        public readonly traceback?: string,
        body?: unknown,
    ) {
        super(500, message, body);
        this.name = "ServerError";
    }
}
